var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-left":"20px"}},[_c('p'),_c('h3',[_vm._v(_vm._s(_vm.$t("pages.Auth.Unauthorized.title")))]),_c('p'),_c('p',[_vm._v(_vm._s(_vm.$t("pages.Auth.Unauthorized.body")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }